import Form from '../../../../kingpin/forms/Form';
import FormHeader from '../../../../kingpin/forms/FormHeader';
import FormContent from '../../../../kingpin/forms/FormContent';
import Row from '../../../Common/Row';
import Button from '../../../../kingpin/atoms/Button';
import Inputs from 'components/Inputs';
import React from 'react';

const AssignBoardOwnersPopup = ({
  close,
  ownersGreenList,
  isLoading,
  owners,
  onOwnerAdded,
  onOwnerRemoved,
}: {
  close: () => void;
  ownersGreenList: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  isLoading: boolean;
  owners: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  onOwnerAdded: (
    user: UserManagement.PendingUser | UserManagement.SignedUpUser,
  ) => Promise<void>;
  onOwnerRemoved: (
    user: UserManagement.PendingUser | UserManagement.SignedUpUser,
  ) => Promise<void>;
}) => {
  return (
    <Form>
      <FormHeader
        title={'Select Board Owner(s)'}
        onClose={close}
        subTitle={'Choose who can manage and sign off on this board.'}
      />
      <FormContent style={{ gap: 16 }}>
        <Inputs.AddUsersSearch
          isLoading={isLoading}
          selectedUsers={owners}
          onUserAdded={onOwnerAdded}
          usersGreenList={ownersGreenList}
        />
        <Inputs.UsersList
          isLoading={isLoading}
          users={owners}
          onUserRemoved={onOwnerRemoved}
          emptyMessage={'No owner assigned yet'}
        />
      </FormContent>
      <Row centerAlign style={{ justifyContent: 'flex-end' }}>
        <Button
          size={'Medium'}
          type={'Primary'}
          onClick={close}
          label={'Close'}
        />
      </Row>
    </Form>
  );
};

export default AssignBoardOwnersPopup;
